<template>
  <div>
     Hi
  </div>
</template>

<script>
export default {
  name: 'UserSite',
  methods:{
   
  }
}
</script>

<style lang="scss">
  nav {
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserSite.vue